import { FC, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { $RootTraffic, $UserAgent } from '@lemon8/web-app-shared/atom';
import { PageTypeUtils } from '~/utils/page-type-utils';

export const PageShowReporter: FC = () => {
  const traffic = useAtomValue($RootTraffic);
  const { isInApp } = useAtomValue($UserAgent);

  useEffect(() => {
    if (!isInApp) {
      const { enterPageName, enterHref } = traffic;

      const url = new URL(enterHref);
      const pid = PageTypeUtils.getPageTypeFromPathname(url.pathname);
      if (enterPageName === 'legal_unavailable') {
        window.Tea('geoblock_web_page_show', {
          pageName: enterPageName,
          pid,
        });
      } else {
        window.Tea('rd_legal_pageshow', {
          pageName: enterPageName,
          pid,
        });
      }

    }
  }, [traffic]);

  return null;
};
